var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjectTruckMinor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.88013,
    width: 53,
    height: 53,
    rx: 6.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.88013,
    width: 53,
    height: 53,
    rx: 6.5,
    stroke: "#0089EC",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8485 26.7719L35.2145 21.9373H29.3128V19.7367C29.3018 18.9009 28.981 18.0988 28.4126 17.486C27.8221 16.9216 27.0281 16.6208 26.2119 16.6524V18.5197C26.8346 18.4617 27.3863 18.9195 27.4443 19.5421C27.4503 19.6068 27.4507 19.6719 27.4456 19.7367V28.6892L27.4289 34.7743H25.9118C24.8405 33.2509 22.7401 32.8785 21.2104 33.9407C20.8924 34.1753 20.6114 34.4563 20.3768 34.7743H19.1432C18.0613 33.2505 15.949 32.8922 14.4252 33.974C12.9014 35.0559 12.5431 37.1682 13.6249 38.692C14.7068 40.2159 16.8191 40.5741 18.3429 39.4923C18.3429 39.4923 18.343 39.4923 18.343 39.4923C19.2296 38.8485 19.756 37.8205 19.76 36.7248V36.6415H19.7767C19.7767 36.6749 19.76 36.6915 19.76 36.7248C19.7642 38.5939 21.2827 40.1058 23.1518 40.1016C25.0151 40.0975 26.5245 38.5881 26.5286 36.7248V36.6415H34.4976V36.7248C34.4985 38.5939 36.0145 40.1084 37.8836 40.1075C39.7449 40.1066 41.2561 38.6028 41.2662 36.7415V36.6415H43V26.7719H37.8485ZM16.3758 38.2419C15.5379 38.242 14.8586 37.5627 14.8586 36.7249C14.8586 35.887 15.5378 35.2077 16.3757 35.2077C17.2135 35.2077 17.8928 35.8869 17.8928 36.7248C17.8928 36.7248 17.8928 36.7248 17.8928 36.7249C17.8897 37.5615 17.2123 38.2389 16.3758 38.2419ZM23.1444 38.2419C22.3065 38.242 21.6272 37.5627 21.6272 36.7249C21.6272 35.887 22.3064 35.2077 23.1443 35.2077C23.9821 35.2077 24.6614 35.8869 24.6614 36.7248C24.6614 36.7248 24.6614 36.7248 24.6614 36.7249C24.6583 37.5615 23.9809 38.2389 23.1444 38.2419ZM37.8819 38.2419C37.044 38.2419 36.3648 37.5627 36.3649 36.7248C36.3649 35.8869 37.0441 35.2077 37.882 35.2077C38.7199 35.2077 39.3991 35.887 39.3991 36.7249C39.3991 36.7249 39.3991 36.7249 39.3991 36.7249C39.3961 37.5615 38.7185 38.239 37.8819 38.2419H37.8819ZM41.1329 34.7743H40.6494C39.5703 33.2459 37.4565 32.8817 35.9281 33.9608C35.6125 34.1836 35.3373 34.4588 35.1145 34.7743H29.3128V23.8045H34.1142L36.2148 27.6723L36.7483 28.6392H41.1329L41.1329 34.7743Z",
    fill: "#0089EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectTruckMinor);
export default __webpack_public_path__ + "static/media/object-truck-minor.27a3add2c7e776555f7c0d72067094f8.svg";
export { ForwardRef as ReactComponent };